export default "<app-carousel></app-carousel>\n<!-- <app-block></app-block> -->\n\n";